const SELECTOR = 'select.links-dropdown';

function onDocumentReady() {
	const els = document.querySelectorAll(SELECTOR);

	if (!els) {
		return;
	}

	els.forEach(el => el.addEventListener('change', comeSailAway));
}

function comeSailAway(e) {
	const target = e.target;

	window.location.href = target.value;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);